import { apiClient, type PageEntity, type TaxCategoryEntity } from '@/libs/api'
import { type TaxCategoriesListRequestQuery } from '@/libs/api/types'

export type FetchTaxCategoriesListQuery = {
  tenantKey: string
  query?: TaxCategoriesListRequestQuery
}

export type FetchTaxCategoriesListResponse = {
  data: TaxCategoryEntity[]
  pagination: PageEntity | null
}

// 税区分マスタ管理画面用一覧取得API（#4209: ADMIN は全拠点表示）
export const fetchTaxCategoriesList = async (
  { tenantKey, query }: FetchTaxCategoriesListQuery,
  signal?: AbortSignal
): Promise<FetchTaxCategoriesListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .tax_categories.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
